import { Controller } from "@hotwired/stimulus"
import Logger from "../lib/logger"

export default class extends Controller {
  static targets = ["pair", "loadingOverlay"]

  connect() {
    Logger.debug("AddressDeduplicationController connected")
    this.restoreActiveTab()
    this.bindTabEvents()

    this.handleSubmitEnd = this.handleSubmitEnd.bind(this)
    this.element.addEventListener("turbo:submit-end", this.handleSubmitEnd)
  }

  disconnect() {
    Logger.debug("AddressDeduplicationController disconnected")
    this.cleanupTabEvents()
    this.element.removeEventListener("turbo:submit-end", this.handleSubmitEnd)
  }

  restoreActiveTab() {
    const activeTabId = localStorage.getItem("address_dedup_active_tab")
    if (activeTabId) {
      const tabButton = this.element.querySelector(`#${activeTabId}`)
      if (tabButton && typeof bootstrap !== "undefined" && bootstrap.Tab) {
        const tab = bootstrap.Tab.getOrCreateInstance(tabButton) || new bootstrap.Tab(tabButton)
        tab.show()
      }
    }
  }

  bindTabEvents() {
    const tabsContainer = this.element.querySelector("#deduplicationTabs")
    if (tabsContainer) {
      this.tabShownHandler = (event) => {
        if (event.target && event.target.id) {
          localStorage.setItem("address_dedup_active_tab", event.target.id)
        }
      }
      tabsContainer.addEventListener("shown.bs.tab", this.tabShownHandler)
    }
  }

  cleanupTabEvents() {
    const tabsContainer = this.element.querySelector("#deduplicationTabs")
    if (tabsContainer && this.tabShownHandler) {
      tabsContainer.removeEventListener("shown.bs.tab", this.tabShownHandler)
    }
  }

  showLoading() {
    if (this.hasLoadingOverlayTarget) {
      this.loadingOverlayTarget.classList.add("active")
    }
  }

  merge(event) {
    const pairId = event.currentTarget.dataset.pairId
    const pairElement = this.pairTargets.find(el => el.dataset.pairId === pairId)

    if (pairElement) {
      pairElement.classList.add("merging")
    }
  }

  dismiss(event) {
    const pairId = event.currentTarget.dataset.pairId
    const pairElement = this.pairTargets.find(el => el.dataset.pairId === pairId)

    if (pairElement) {
      pairElement.classList.add("merging")
    }
  }

  handleSubmitEnd(event) {
    const { success } = event.detail
    if (!success) {
      const submitter = event.detail.formSubmission?.submitter
      const pairId = submitter?.dataset?.pairId
      if (pairId) {
        const pairElement = this.pairTargets.find(el => el.dataset.pairId === pairId)
        if (pairElement) {
          pairElement.classList.remove("merging")
        }
      }
      return
    }

    const form = event.target
    if (!form || !form.action) return

    try {
      const url = new URL(form.action, window.location.origin)
      if (url.pathname.includes("/addresses/deduplication/merge")) {
        const formData = new FormData(form)
        const removeId = formData.get("remove_id")
        if (removeId) {
          Logger.info(`Address #${removeId} has been deleted/merged. Cleaning up other pairs referencing it.`)

          this.pairTargets.forEach(el => {
            if (el.dataset.keepId === removeId || el.dataset.removeId === removeId) {
                 el.classList.add("address-dedup-fade-out")

                setTimeout(() => {
                 el.remove()
              }, 300)
            }
          })
        }
      }
    } catch (e) {
      Logger.error("Failed to parse form action in handleSubmitEnd", e)
    }
  }
}

